import React from "react";
import useHubspotEmbed from "@/hooks/forms/use-hubspot-embed";
import {HubSpotFormInfo} from "@/types/dto/common/hubspot";
import {Box, Stack, Typography} from "@mui/material";
import {ColletteIconButton} from "@collette-travel/collette-common-controls";
import {Close} from "@mui/icons-material";
import HubspotEmbed from "@/components/forms/hubspot-embed";
import HubspotFormDisclaimer from "@/components/forms/disclaimer/hubspot-form-disclaimer";

interface GenericHubspotProps {
  form: HubSpotFormInfo;
  onSubmit?: () => void;
  handleClose: () => void;
  testId: string;
  targetId?: string;
}

const GenericHubspotForm = ({
  form,
  onSubmit,
  handleClose,
  testId,
  targetId
}: GenericHubspotProps) => {
  const {
    formId,
    formTitle,
    formName,
    portalId
  } = form;
  
  const {
    dataLayerProps,
    isLoading,
    isSubmitted,
    targetId: resolvedTargetId
  } = useHubspotEmbed({
    formId,
    portalId,
    formName,
    onSubmit,
    ...(targetId ? { targetId } : {})
  });
  
  return (
    <Stack
      sx={{
        backgroundColor: "background.default",
        padding: "4rem 4rem 2rem",
        gap: "2.4rem"
      }}
      id={`hubspot-embed-${testId}`}
    >
      <Stack
        sx={{
          flexDirection: "row",
          justifyContent: "space-between"
        }}
      >
        <Typography
          component="p"
          variant="h5"
          data-testid={`${testId}-header`}
        >
          {formTitle}
        </Typography>
        <ColletteIconButton
          testId={`${testId}-close-button`}
          onClick={handleClose}
          sx={{
            mt: "-0.8rem",
            mr: "-0.8rem"
          }}
        >
          <Close />
        </ColletteIconButton>
      </Stack>
      <Box
        sx={{
          opacity: isLoading ? 0 : 1,
          transition: "opacity 0.5s ease-in"
        }}
      >
        <HubspotEmbed
          formId={formId}
          dataLayerProps={dataLayerProps}
          targetId={resolvedTargetId ?? targetId}
        />
      </Box>
      {!isSubmitted && (
        <HubspotFormDisclaimer testId={`${testId}-form-disclaimer`} />
      )}
    </Stack>
  );
};

export default GenericHubspotForm;